import { useActiveJob } from '../../hooks/active-job.hook';
import { JobDetailsTitle } from '../titles/JobDetailsTitle';

export const JobDetailsPageNav = (): React.ReactElement<any, any> | null => {
    const { job, deleted, fetch, update } = useActiveJob();

    return <JobDetailsTitle job={job} hideLoader={!!(deleted || fetch.error || update.error)} />;
};
